// src/pages/Blogs.jsx
import BlogCard from "../components/BlogCard";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";
import { blogs } from "../data/blogs.js";

const Blogs = () => {
  return (
    <>
      <Navbar />
      <div className=" px-16 py-10  text-white" id="blogs">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-14 mb-4 ">
          {blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>
      </div>
      
    
  

export default BlogPost;

      <Footer />
    </>
  );
};

export default Blogs;
